import { AuthClient } from "@/utils/client";

export const getPackages = () => {
  return AuthClient().get(`/common/get-packages`);
};
